import { FooterItems, SocialTour, TourInfoItems, TourStepItem } from "../../types/BonusUi";

export const TourInfoData: TourInfoItems[] = [
  {
    iconClass: "envelope",
    text: "   Email",
    spanText: "William@jourrapide.com",
  },
  {
    iconClass: "calendar",
    text: "   BOD",
    className: "ttl-sm-mb-0",
    spanText: "02 January 1988",
  },
];

export const TourAddressData: TourInfoItems[] = [
  {
    colClass: "mt-0 mt-sm-3",
    iconClass: "phone",
    text: "   Contact Us",
    className: "ttl-xs-mt",

    spanText: "US 310-273-0666",
  },
  {
    iconClass: "location-arrow",
    text: "   Location",
    className: "ttl-sm-mb-0",
    spanText: "4377 Libby Street Beverly Hills",
  },
];

export const SocialData: SocialTour[] = [
  {
    href: "https://www.facebook.com/",
    icon: "fa fa-facebook",
  },
  {
    href: "https://accounts.google.com/",
    icon: "fa fa-google-plus",
  },
  {
    href: "https://twitter.com/",
    icon: "fa fa-twitter",
  },
  {
    href: "https://www.instagram.com/",
    icon: "fa fa-instagram",
  },
  {
    href: "https://rss.app/",
    icon: "fa fa-rss",
  },
];

export const CommonFooterData: FooterItems[] = [
  {
    className: "b-r-gray pe-3",
    icon: "heart",
    text: " Like",
  },
  {
    className: "b-r-gray pe-3",
    icon: "comment",
    text: " Comment",
  },
  {
    icon: "paper-plane",
    text: " Share",
  },
];

//Tour
export const TourSteps: TourStepItem[] = [
  {
    target: ".step1",
    content: "This is Zono profile",
  },
  {
    target: ".step2",
    content: "Change Zono profile image here",
  },
  {
    target: ".step3",
    content: "This is your profile details",
  },
  {
    target: ".step4",
    content: "This is your social details",
  },
  {
    target: ".step5",
    content: "This is your first Post",
  },
  {
    target: ".step6",
    content: "This is your social details",
  },
  {
    target: ".step7",
    content: "This is your social details",
  },
  {
    target: ".step8",
    content: "This is your social details",
  },
  {
    target: ".step9",
    content: "This is your social details",
  },
];

export const PainterTourParagraph: string = "you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet.";
export const WonderfulTour: string = "Wonderful piece that successfully conveys the magnificence of the mountains and the natural world.";
export const PainterTour: string = " Is most renowned for his expressive colorization, creative landscapes, and stormy, sometimes violent maritime works. However, this moody image of the Devil's Bridge in Switzerland, close to the Goatherd Pass, feels incredibly authentic and accurately depicts historical occasions when Russian general Sunroof crossed the Alps and fought not only far larger enemy troops!";
export const PainterTourSpan: string = "The curved canvas is enclosed in a complex frame that the artist created but that his buddy Goalie Christian Kuhn carved. A variety of Christian symbols are depicted on the frame, including the faces of five infant angels, a star, grapes, vines, corn, and God's eye.Many of the Romantic elements and subjects that he would explore throughout his career are present in this work, one of his earliest, most notable of which is the landscape's significant significance. In spite of the altarpiece's inclusion of a crucifix, the emphasis is";
export const PainterTourTitle: string = "English Romantic painter, printer, and water colorist ";
